type Props = {
    title: string
    cover?: string
}

export const CourseCover = ({title, cover}: Props) => {
    return cover ? (
        <img
            src={normalizeUrl(cover)}
            alt={title}
            className="w-14 h-14 rounded-xl object-cover shadow-sm"
        />
    ) : (
        <div className="
            w-14 h-14 rounded-xl
            bg-gradient-to-br from-emerald-400 to-emerald-600
            text-white flex items-center justify-center
            font-bold
        ">
            {title?.[0]?.toUpperCase() ?? "C"}
        </div>
    )
}


const normalizeUrl = (url: string) => {
  if (!url) return ""
  if (url.startsWith("http")) return url
  return `https://${url}`
}